// extracted by mini-css-extract-plugin
module.exports = {"container":"_1xWFoeYykLJ9jTLgcquRdm","groupsList":"_1mSDgTG6VD6ymmZMjCOyO9"};